/* 🤖 this file was generated by svg-to-ts */
export const matIconDiamond: {
  name: 'diamond';
  data: string;
} = {
  name: 'diamond',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3H5L2 9l10 12L22 9l-3-6zM9.62 8l1.5-3h1.76l1.5 3H9.62zM11 10v6.68L5.44 10H11zm2 0h5.56L13 16.68V10zm6.26-2h-2.65l-1.5-3h2.65l1.5 3zM6.24 5h2.65l-1.5 3H4.74l1.5-3z"/></svg>`
};
